import Button from "@/components/bricks/button/Button";
import PlusIcon from "../../icons/PlusIcon";
import Modal, {
  ModalContext,
  ModalProvider,
  ModalTrigger,
} from "../../Modal/Modal";
import { useContext, useEffect } from "react";
import { useOpretFirma } from "./hooks/useOpretFirma";
import FirmaIcon from "../../icons/FirmaIcon";
import OpretFirmaStep1 from "./steps/step1/OpretFirmaStep1";
import { WizardReceipt } from "../common/wizardReceipt";
import { useNavigate } from "react-router-dom";
import OpretFirmaStep2 from "./steps/step2/OpretFirmaStep2";

const OpretFirmaModal = () => {
  const { setModalOpen, modalOpen } = useContext(ModalContext);
  const navigate = useNavigate();
  const {
    setStep,
    step,
    step1,
    step2,
    produktionsEnheder,
    searchResult,
    setProduktionsEnheder,
    setSearchResult,
    opretFirmaQuery,
  } = useOpretFirma();
  const { isPending, error, data } = opretFirmaQuery;

  useEffect(() => {
    if (!modalOpen) {
      setStep(1);
      step1.resetForm();
      step2.resetForm();
      setProduktionsEnheder([]);
      setSearchResult(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen]);
  const receiptHeading = isPending
    ? "Opretter firma ..."
    : error
      ? "Kunne ikke oprette firma"
      : data
        ? `${data.navn1} oprettet`
        : "What is this state?";

  return (
    <Modal
      dialog
      title={
        <>
          <FirmaIcon width={24} /> Opret nyt firma{" "}
          <span className="c-modal-steps">{step < 3 ? `${step} / 2` : ""}</span>
        </>
      }
      description=""
    >
      <div className="c-modal-container">
        {step === 1 && (
          <OpretFirmaStep1
            setModalOpen={setModalOpen}
            formik={step1}
            produktionsEnheder={produktionsEnheder}
            searchResult={searchResult}
            setProduktionsEnheder={setProduktionsEnheder}
            setSearchResult={setSearchResult}
          />
        )}
        {step === 2 && (
          <OpretFirmaStep2 formik={step2} setStep={setStep} step1={step1} />
        )}
        {step === 3 && (
          <>
            <WizardReceipt
              heading={receiptHeading}
              icon={isPending ? "loading" : data ? "success" : "warning"}
            >
              <p className="text-muted text-center">
                {error
                  ? (error as any).data?.Message
                  : isPending
                    ? ""
                    : "Luk for at gå til det nye firma"}
              </p>
            </WizardReceipt>
            <div className="flex-100 d-flex justify-content-center mt-3">
              <Button
                color="secondary"
                onClick={() => {
                  if (data) {
                    setModalOpen(false);
                    navigate("/firma/" + data.id);
                    step1.resetForm();
                  }
                  setStep(1);
                }}
              >
                {data && "Luk"}
                {!data && "Ret data"}
              </Button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

const OpretFirma = () => {
  return (
    <ModalProvider>
      <ModalTrigger asChild>
        <Button className="mx-3" transparent color="primary" onClick={() => {}}>
          <PlusIcon width={18} /> Opret firma
        </Button>
      </ModalTrigger>
      <OpretFirmaModal />
    </ModalProvider>
  );
};

export default OpretFirma;
